import { render, staticRenderFns } from "./VinylPostcardsAudioPlayer.vue?vue&type=template&id=23013fda&"
import script from "./VinylPostcardsAudioPlayer.vue?vue&type=script&lang=ts&"
export * from "./VinylPostcardsAudioPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./VinylPostcardsAudioPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports